import { render, staticRenderFns } from "./paymentCollection.vue?vue&type=template&id=32547e16"
import script from "./paymentCollection.vue?vue&type=script&lang=js"
export * from "./paymentCollection.vue?vue&type=script&lang=js"
import style0 from "./paymentCollection.vue?vue&type=style&index=0&id=32547e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports